"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Research = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Research = (function (_super) {
    __extends(Research, _super);
    function Research() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.RESEARCH,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.SCIENCE],
            cost: 11,
            metadata: {
                cardNumber: '090',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.cards(2);
                }),
                description: 'Counts as playing 2 science cards. Draw 2 cards.',
                victoryPoints: 1,
            },
        }) || this;
    }
    Research.prototype.play = function (player) {
        player.drawCard(2);
        return undefined;
    };
    Research.prototype.getVictoryPoints = function () {
        return 1;
    };
    return Research;
}(Card_1.Card));
exports.Research = Research;
//# sourceMappingURL=Research.js.map